import * as React from 'react';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import { Label } from '../../typography';
import { ColorResult, CirclePicker } from 'react-color';
import Box from '../primitives/Box';
// import { themeGet } from 'styled-system';

type Props = StyledSystemProps & {
  bg?: string;
  name?: string;
  type?: string;
  color?: string;
  width?: string;
  height?: string;
  paddingLeft?: string;
  boxShadow?: string;
  placeholder?: string;
  showEyeIcon?: boolean;
  passwordVisible?: boolean;
  children?: React.ReactNode;
  onTogglePassword?: () => void;
  disabled?: boolean;
  borderRadius?: string | number;
  id?: string;
  onChange?: (e: any) => void;
  autoComplete?: string;
  value?: string;
  min?: number;
  max?: number;
  field: any;
  label: string;
  form: any;
};

const ColorPicker: React.FC<Props> = (props: Props) => {
  const [open, setOpen] = React.useState(false);
  const { field: { value, name }, form } = props;
  console.log(props);
  return (
    <Box {...props} onClick={() => setOpen(true)}>
      <Label>{props.label}</Label>
      {!open && <div style={{
        backgroundColor: value || '#FFF',
        height: 40,
        borderRadius: 4,
        border: '1px solid rgba(50,50,93,0.2)',
        alignItems: 'center',
        display: 'flex',
        paddingLeft: 10,
      }}>
        <span style={{ color: '#FFF', textTransform: 'uppercase' }}>{value}</span>
      </div>}
      {open &&
        <div style={{
          backgroundColor: '#FFF',
          borderRadius: 4,
          border: '1px solid rgba(50,50,93,0.2)',
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          paddingTop: 10,
          paddingBottom: 10,
        }}>
          <CirclePicker
            color={value || '#FFF'}
            onChangeComplete={(color: ColorResult) => { form.setFieldValue(name, color.hex); setOpen(false) }}
          />
        </div>}
    </Box>
  );
};

export default ColorPicker;

ColorPicker.defaultProps = {
  field: { value: '' },
  borderRadius: 4,
  flex: 1,
  minWidth: '150px',
};



// WEBPACK FOOTER //
// ./src/components/formElements/StyledColorPicker.tsx